import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import {omit} from 'ramda';

import {Drawer as DXDrawer} from 'devextreme-react';


export default class Drawer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            opened: this.props.opened,
            // value: this.props.value,
            visible: this.props.visible,
            // isValid: this.props.isValid,
            // disabled: this.props.disabled,
        };

        // this.onValueChanged = this.onValueChanged.bind(this);
        this.itemTemplate = this.itemTemplate.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            opened: props.opened,
            // disabled: props.disabled,
        });
    }

    // static getDerivedStateFromProps(nextProps, prevState){
    //     if ((nextProps.visible !== prevState.visible) || (nextProps.opened !== prevState.opened)) {
    //         return {
    //             // visible: nextProps.visible,
    //             opened: nextProps.opened,
    //         };
    //     }
    //     return null;
    // }

    //
    // onValueChanged(e) {
    //     const {setProps} = this.props;
    //
    //     this.setState({value: e.value});
    //     if (setProps) setProps({value: e.value});
    // }

    itemTemplate(template_id) {
        var tmpl = window[template_id];
        return function(element) {
            ReactDOM.render(tmpl(), element);
        }
    }

    render() {
        let {itemTemplate} = this.props;

        if (itemTemplate && typeof itemTemplate === 'string' && itemTemplate !== 'panel'){
            itemTemplate = this.itemTemplate(itemTemplate);
        }

        // if (component && typeof component === 'string'){
        //     component = this.template(component);
        // }
        // if (render && typeof render === 'string'){
        //     render = this.template(render);
        // }

        return (
            <DXDrawer
                {...omit(['setProps'], this.props)}
                opened={this.state.opened}
                // value={this.state.value}
                // visible={this.state.visible}
                // isValid={this.state.isValid}
                // disabled={this.state.disabled}
                // onValueChanged={this.onValueChanged}

                // component={component}
                // render={render}
                template={itemTemplate}
            />
        )
    }
}

Drawer.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,
    /**
     * A collection of an node's child elements
     */
    children: PropTypes.node,

    /**
     * Specifies whether or not the UI component changes its state when interacting with a user
     */
    activeStateEnabled: PropTypes.bool,
    /**
     * Specifies the duration of the drawer's opening and closing animation (in milliseconds)
     */
    animationDuration: PropTypes.number,
    /**
     * Specifies whether to use an opening and closing animation
     */
    animationEnabled: PropTypes.bool,
    /**
     * Specifies whether to close the drawer if a user clicks or taps the view area
     */
    closeOnOutsideClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    /**
     * An alias for the template property specified in React. Accepts a custom component.
     */
    itemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies the view's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether the UI component changes its state when a user pauses on it
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * Specifies the drawer's width or height (depending on the drawer's position) in the opened state
     */
    maxSize: PropTypes.number,
    /**
     * Specifies the drawer's width or height (depending on the drawer's position) in the closed state
     */
    minSize: PropTypes.number,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * Specifies whether the drawer is opened
     */
    opened: PropTypes.bool,
    /**
     * Specifies how the drawer interacts with the view in the opened state
     */
    openedStateMode: PropTypes.oneOf(['overlap', 'shrink', 'push']),
    /**
     * Specifies the drawer's position in relation to the view
     */
    position: PropTypes.oneOf(['left', 'right', 'top', 'bottom', 'before', 'after']),
    /**
     * An alias for the template property specified in React. Accepts a rendering function.
     */
    itemRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies the drawer's reveal mode
     */
    revealMode: PropTypes.oneOf(['slide', 'expand']),
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * Specifies whether to shade the view when the drawer is opened
     */
    shading: PropTypes.bool,
    /**
     * Specifies a CSS selector for the element in which the drawer should be rendered. Applies only when the openedStateMode is "overlap"
     */
    target: PropTypes.string,
    /**
     * Specifies the drawer's content
     */
    itemTemplate: PropTypes.string,
    /**
     * Specifies whether the Drawer UI component (including the view) is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the view's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func,
};

Drawer.defaultProps = {
    activeStateEnabled: false,
    animationDuration: 400,
    animationEnabled: true,
    closeOnOutsideClick: false,
    itemComponent: null,
    disabled: false,
    elementAttr: {},
    // height: undefined,
    // hint: undefined,
    hoverStateEnabled: false,
    maxSize: null,
    minSize: null,
    onDisposing: null,
    onInitialized: null,
    onOptionChanged: null,
    opened: false,
    openedStateMode: 'overlap',
    position: 'left',
    itemRender: null,
    revealMode: 'slide',
    rtlEnabled: false,
    shading: false,
    // target
    itemTemplate: 'panel',
    visible: true,
    // width: undefined
};
